// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GetTradeCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTradeCategoriesQuery = { __typename?: 'Query', tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string, number: string }> };

export type GetTradeCategoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetTradeCategoryQuery = { __typename?: 'Query', tradeCategory: { __typename?: 'TradeCategory', id: string, name: string, number: string } };

export type SaveTradeCategoryMutationVariables = Types.Exact<{
  input: Types.SaveTradeCategoryInput;
}>;


export type SaveTradeCategoryMutation = { __typename?: 'Mutation', saveTradeCategory: { __typename?: 'SaveTradeCategoryResult', tradeCategory: { __typename?: 'TradeCategory', id: string, name: string, number: string } } };

export type TradeCategoryInfoFragment = { __typename?: 'TradeCategory', id: string, name: string, number: string };

export const TradeCategoryInfoFragmentDoc = gql`
    fragment TradeCategoryInfo on TradeCategory {
  id
  name
  number
}
    `;
export const GetTradeCategoriesDocument = gql`
    query GetTradeCategories {
  tradeCategories {
    ...TradeCategoryInfo
  }
}
    ${TradeCategoryInfoFragmentDoc}`;

/**
 * __useGetTradeCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTradeCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradeCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradeCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTradeCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>(GetTradeCategoriesDocument, options);
      }
export function useGetTradeCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>(GetTradeCategoriesDocument, options);
        }
export function useGetTradeCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>(GetTradeCategoriesDocument, options);
        }
export type GetTradeCategoriesQueryHookResult = ReturnType<typeof useGetTradeCategoriesQuery>;
export type GetTradeCategoriesLazyQueryHookResult = ReturnType<typeof useGetTradeCategoriesLazyQuery>;
export type GetTradeCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTradeCategoriesSuspenseQuery>;
export type GetTradeCategoriesQueryResult = Apollo.QueryResult<GetTradeCategoriesQuery, GetTradeCategoriesQueryVariables>;
export const GetTradeCategoryDocument = gql`
    query GetTradeCategory($id: ID!) {
  tradeCategory(id: $id) {
    ...TradeCategoryInfo
  }
}
    ${TradeCategoryInfoFragmentDoc}`;

/**
 * __useGetTradeCategoryQuery__
 *
 * To run a query within a React component, call `useGetTradeCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradeCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradeCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTradeCategoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTradeCategoryQuery, GetTradeCategoryQueryVariables> & ({ variables: GetTradeCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>(GetTradeCategoryDocument, options);
      }
export function useGetTradeCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>(GetTradeCategoryDocument, options);
        }
export function useGetTradeCategorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>(GetTradeCategoryDocument, options);
        }
export type GetTradeCategoryQueryHookResult = ReturnType<typeof useGetTradeCategoryQuery>;
export type GetTradeCategoryLazyQueryHookResult = ReturnType<typeof useGetTradeCategoryLazyQuery>;
export type GetTradeCategorySuspenseQueryHookResult = ReturnType<typeof useGetTradeCategorySuspenseQuery>;
export type GetTradeCategoryQueryResult = Apollo.QueryResult<GetTradeCategoryQuery, GetTradeCategoryQueryVariables>;
export const SaveTradeCategoryDocument = gql`
    mutation SaveTradeCategory($input: SaveTradeCategoryInput!) {
  saveTradeCategory(input: $input) {
    tradeCategory {
      ...TradeCategoryInfo
    }
  }
}
    ${TradeCategoryInfoFragmentDoc}`;
export type SaveTradeCategoryMutationFn = Apollo.MutationFunction<SaveTradeCategoryMutation, SaveTradeCategoryMutationVariables>;

/**
 * __useSaveTradeCategoryMutation__
 *
 * To run a mutation, you first call `useSaveTradeCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradeCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradeCategoryMutation, { data, loading, error }] = useSaveTradeCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradeCategoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradeCategoryMutation, SaveTradeCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradeCategoryMutation, SaveTradeCategoryMutationVariables>(SaveTradeCategoryDocument, options);
      }
export type SaveTradeCategoryMutationHookResult = ReturnType<typeof useSaveTradeCategoryMutation>;
export type SaveTradeCategoryMutationResult = Apollo.MutationResult<SaveTradeCategoryMutation>;
export type SaveTradeCategoryMutationOptions = Apollo.BaseMutationOptions<SaveTradeCategoryMutation, SaveTradeCategoryMutationVariables>;